import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from 'sonner';

// Components
import Navigation from "@/components/Navigation";
import HeroSection, { FourPillars } from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import WhoWeWorkWith from "@/components/WhoWeWorkWith";
import WhyThisMatters from "@/components/WhyThisMatters";
import ProjectsSection from "@/components/ProjectsSection";
import AIInfrastructureSection from "@/components/AIInfrastructureSection";
import EnterpriseUseCases from "@/components/EnterpriseUseCases";
import EngagementProcess from "@/components/EngagementProcess";
import ConsultancySection from "@/components/ConsultancySection";
import WhyCelestialMinds from "@/components/WhyCelestialMinds";
import QASection from "@/components/QASection";
import EvolutionSection from "@/components/EvolutionSection";
import ContributionSection from "@/components/ContributionSection";
import InvestorSection from "@/components/InvestorSection";
import IntelligenceSection from "@/components/IntelligenceSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import AlphaChat from "@/components/AlphaChat";

const Home = () => {
  return (
    <div className="relative">
      {/* Grain overlay - subtle */}
      <div className="grain-overlay" style={{ opacity: 0.015 }} />
      
      {/* Main content */}
      <main>
        <HeroSection />
        <FourPillars />
        <AboutSection />
        <WhoWeWorkWith />
        <WhyThisMatters />
        <ProjectsSection />
        <AIInfrastructureSection />
        <EnterpriseUseCases />
        <EngagementProcess />
        <ConsultancySection />
        <WhyCelestialMinds />
        <QASection />
        <EvolutionSection />
        <ContributionSection />
        <InvestorSection />
        <IntelligenceSection />
        <ContactSection />
      </main>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App bg-[#050505] min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
      {/* Alpha AI Assistant - floating on every page */}
      <AlphaChat />
      {/* Global Toast notifications - outside routes for persistence */}
      <Toaster 
        position="bottom-right" 
        theme="dark"
        richColors
        toastOptions={{
          style: {
            background: '#0A0A0A',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            color: '#E0E0E0',
            zIndex: 99999,
          },
          className: 'sonner-toast',
        }}
      />
    </div>
  );
}

export default App;
